import React from "react";
import { Link } from "react-router-dom";
import { BsArrowRightShort } from "react-icons/bs";
import { useNavContext } from "../../context-api/nav-context";
import callout from "../../Assets/Images/homeValues/boiler-callout.png";

const BoilerWarranty = () => {
  const { closeNavbarMenu } = useNavContext();
  return (
    <section className="home-values" onMouseOver={closeNavbarMenu}>
      <div className="wrapper two-columns">
        <div className="home-values-left">
          <h1 className="title title-value">
            Up To 10yr Warrenty With AquaHeat
          </h1>
          <Link to="/boilers" className="btn-hero btn-quote btn-home-values">
            Get Instant Boiler Quote
            <BsArrowRightShort class="btn-arrow" />
          </Link>
          <div className="home-values-text">
            <h3 className="home-values-subtitle">
              Servicing Over 8000 homes and businesses
            </h3>
            <p className="home-values-p">
              We have a trained team of Gas Safe registered engineers and
              plumbers with a wide range of plumbing experience. Our plumbers
              are available for 24/7 call outs or for regular boiler maintenance
              work or new boiler installations.
            </p>
          </div>
        </div>
        <div className="home-values-right">
          <div className="home-values-images">
            <img src={callout} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BoilerWarranty;
